import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecuritySetupAuditTrailGraphSlice } from './get';

export const coreDataSecuritySetupAuditTrailGraphReducers = combineReducers({
	get: getCoreDataSecuritySetupAuditTrailGraphSlice.asyncReducers
});

export const coreDataSecuritySetupAuditTrailGraphWatchers = combineAllWatchers([
	getCoreDataSecuritySetupAuditTrailGraphSlice.asyncWatchers
]);
